import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Delivery } from 'src/app/models/delivery.schema';
import { RefundRequest } from 'src/app/models/refund-request.schema';
import { RefundRequestsService } from 'src/app/services/refund-requests.service';
import { CommanUsesService } from 'src/app/services/comman-uses.service';

@Component({
  selector: 'app-refund-request',
  templateUrl: './refund-request.component.html',
  styleUrls: ['./refund-request.component.scss']
})
export class RefundRequestComponent implements OnInit {

  delivery: Delivery;
  refundRequestForm: any;
  formValidationMsgs: any;
  disableBtn: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { delivery: Delivery },
    private dialogRef: MatDialogRef<RefundRequestComponent>,
    private refundRequestsService: RefundRequestsService,
    private commanUsesService: CommanUsesService,
  ) { 
    this.delivery = this.data.delivery;
    this.refundRequestForm = new FormGroup(RefundRequest.validation());
    this.formValidationMsgs = RefundRequest.validationMessages;
    this.refundRequestForm.controls.expert.controls.id.setValue(this.delivery.expert.id);
    this.refundRequestForm.controls.delivery.controls.id.setValue(this.delivery.id);
  }

  async ngOnInit() {  }

  async onSubmit() {
    try {
      if (this.refundRequestForm.invalid) {
        this.refundRequestForm.markAllAsTouched();
        return;
      }

      this.disableBtn = true;
      const file = this.refundRequestForm.get('receipt')?.value;
      if (file) {
        const formData = new FormData();
        formData.append('receipt', this.refundRequestForm.get('receipt')?.value);
        const formValue = { ...this.refundRequestForm.value };
        delete formValue.receipt;
        formData.append('data', JSON.stringify(formValue));
        let promise = this.refundRequestsService.createRefundRequest(formData);
        promise.then((response: any) => {
          if(response) {
            this.disableBtn = false;
            this.commanUsesService.showSnackBar("LA RICHIESTA DI RIMBORSO È STATA INVIATA");
            this.dialogRef.close(true);
          }
        }).catch((error) => {
          this.disableBtn = false;
          let errorMsg = error?.error?.message;
          if(error?.error?.message === 'REFUND_REQUEST.ALREADY_SUBMITTED' && error?.error?.statusCode === 409) {
            errorMsg = error?.error?.message;
          }
          this.commanUsesService.showSnackBar(errorMsg);
        })
      } else {
        this.disableBtn = false;
        this.commanUsesService.showSnackBar(`PER FAVORE CARICA L'IMMAGINE DI NUOVO`);
      }
    } catch (error) { }
  }

  onFileSelect(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.refundRequestForm.get('receipt')?.setValue(file);
      this.refundRequestForm.get('receipt')?.markAsTouched();
    }
  }


}
